export default __webpack_public_path__ + "static/media/321.30a4ea7b.gif";